import React from 'react';
import { useNavigate } from 'react-router-dom';
// material
import { makeStyles } from '@mui/styles';
import { Card, Box, Grid, Typography, Stack, Skeleton } from '@mui/material';
import { ReactComponent as LiveTripIcon } from '../../../icons/liveTripIcon.svg';
import { ReactComponent as ScheduledTripIcon } from '../../../icons/scheduledTripIcon.svg';
import { ReactComponent as CompletedTripIcon } from '../../../icons/previousTripIcon.svg';
import { URL_CONSTANT } from '../../../URLConstants';

const useStyles = makeStyles({
  customDashCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: '20px',
    minHeight: '190px',
    padding: '15px',
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '20px',
    alignItems: 'center',
    height: '100%'
  }
});

// ----------------------------------------------------------------------

export default function TripCounts({ admindashboardData, loader }) {
  const tripStat = admindashboardData?.trips?.stats || [];

  const tripData = [
    {
      id: 1,
      name: 'Live Trips',
      status: 'STARTED',
      count: tripStat
        .filter((item) => item?.type?.toUpperCase() === 'STARTED')
        .reduce((acc, item) => acc + item.count, 0),
      icon: LiveTripIcon ? <LiveTripIcon /> : null,
      color: '#0DA626'
    },
    {
      id: 2,
      name: 'Previous Trips',
      status: 'COMPLETED',
      count: tripStat
        .filter((item) => item?.type?.toUpperCase() === 'COMPLETED')
        .reduce((acc, item) => acc + item.count, 0),
      icon: CompletedTripIcon ? <CompletedTripIcon /> : null,
      color: '#171D40'
    },
    {
      id: 3,
      name: 'Scheduled Trips',
      status: 'SCHEDULED',
      count: tripStat
        .filter((item) => item?.type?.toUpperCase() === 'SCHEDULED')
        .reduce((acc, item) => acc + item.count, 0),
      icon: ScheduledTripIcon ? <ScheduledTripIcon /> : null,
      color: '#535353'
    }
  ];

  const classes = useStyles();
  const navigate = useNavigate();

  const gotoTripPage = (tripStatus) => {
    if (tripStatus) {
      navigate(URL_CONSTANT.TRIP, { state: { trip: tripStatus } });
    }
  };

  return (
    <Card data-testid="smartlock-tripcounts" className={classes.customDashCard}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        gap="10px"
        sx={{
          width: '350px',
          margin: '0 auto'
        }}
      >
        {loader
          ? [1, 2, 3].map((skeletonId) => (
              <Skeleton
                key={skeletonId}
                variant="rectangular"
                width="90px"
                height="100px"
                sx={{ margin: '0 10px' }}
              />
            ))
          : tripData?.map((item) => (
              <Stack
                key={item.id}
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap="10px"
                sx={{ cursor: 'pointer' }}
                onClick={() => gotoTripPage(item.status)}
              >
                {item.icon}
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: '#171D40',
                    fontSize: { xs: '24px', sm: '32px' },
                    lineHeight: { xs: '32px', sm: '44px' }
                  }}
                >
                  {item.count}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: item.color,
                    fontSize: { xs: '12px', sm: '14px' },
                    lineHeight: '16px',
                    textAlign: 'center'
                  }}
                >
                  {item.name}
                </Typography>
              </Stack>
            ))}
      </Box>
    </Card>
  );
}
